module.exports = __webpack_public_path__ + "static/media/rise.34be4989.png";